// import './BannerDescription.scss'; // не працює на сервері Жовтня

import React from 'react';

import { LinkOutSVG } from '../../../../../shared';

export function BannerDescription({ promoLink } = {}) {
  return <div className='sertificat__text'>
    <div>
      <p className='sertificat__text__paragraph'>
        Пільгові Квитки можна придбати/отримати лише в касі Кінотеатру.
      </p>
      <p className='sertificat__text__paragraph'>
        Перелік категорій осіб, які мають право придбати Квитки на пільгових умовах (за наявності відповідних документів):
      </p>

      <ul className='BenefitsPurchaseTickets__list pl-adaptive-list'>        
        <li className='sertificat__text__paragraph'>Діти до 6 років (без надання додаткового крісла в кінозалі);</li>
        <li className='sertificat__text__paragraph'>Люди з інвалідністю I групи та особи з порушенням опорно-рухового апарату, які пересуваються на кріслах колісних. Для осіб з інвалідністю I групи, та для осіб з порушенням опорно-рухового апарату, які пересуваються на кріслах колісних вартість Квитка складає 1 грн. (одна гривня). Продаж Квитків здійснюється на спеціально визначені місця;</li>
        <li className='sertificat__text__paragraph'>Школярі, студенти, пенсіонери можуть придбати квитки зі знижкою 10 грн. (десять гривень) від ціни Квитка, за умови пред'явлення на касі кінотеатру студентського/пенсійного/учнівського квитка з актуальною датою;</li>
        <li className='sertificat__text__paragraph'>Учасники бойових дій російсько-української війни, військовослужбовці, які стали інвалідами внаслідок бойових дій;</li>
        <li className='sertificat__text__paragraph'>Для учасників бойових дій, військовослужбовців, які отримали  інвалідність внаслідок бойових дій вартість Квитка складає 1грн. (одна гривня). Скористатися пільгою можливо за умови пред’явлення  посвідчення, яке підтверджує статус учасника бойових дій (УБД), або статус особи з інвалідністю внаслідок війни, на касі Кінотеатру;</li>
        <li className='sertificat__text__paragraph'>Особи, які отримали статус внутрішньо переміщеної особи (ВПО), вимушені переселенці, які зареєстровані у Києві та Київській області з 24 лютого 2022 року. Вартість Квитка складає 1 грн. (одна гривня).</li>
      </ul>

      <p className='sertificat__text__paragraph'>
        Ознайомитися більш детально з діючими пільгами та умовами їх надання  ви можете в{' '}
        <a target="_blank" href={process.env.REACT_APP_PDF_PATH_TO_ATTENDANCE_RULES} style={{ color: '#73233c', fontWeight: '700' }}>ПРАВИЛАХ КІНОТЕАТРУ<LinkOutSVG /></a>{' '}        
        пункт 6.
      </p>

      <p className='sertificat__text__paragraph'>
        Для отримання інформації про діючі пільги на певний фільм, необхідно уточнити в касі Кінотеатру, або зателефонувати за номером:
      </p>

      <ul className='pl-adaptive-list'>        
        <li className='sertificat__text__paragraph'><a href='tel:+380673299830'>+380 67 329 98 30</a> – каса Кінотеатру;</li>
        <li className='sertificat__text__paragraph'><a href='tel:+380672475973'>+380 67 247 59 73</a> – менеджер Кінотеатру.</li>
      </ul>
      
    </div>
  </div >
}




// WEBPACK FOOTER //
// ./src/components/snippets/ChiefSliderComponent/entities/items/BenefitsPurchaseTickets/impl/BannerDescription/BannerDescription.jsx